export function composeMixins(Base, ...mixins) {
  return mixins.reduce((accumulatedClass, mixin) => mixin(accumulatedClass), Base);
}
